<template>
  <div class="knowledge-base-wrap">
    <h1> {{'База знаний'}}</h1>
    <div class="content-filters">
      <div class="row">
        <div class="col-lg-4">
          <vSelect
              label="name"
              placeholder="Назначение"
              v-model="appointment"
              :options="appointments"
          />
        </div>
        <div class="col-lg-4">
          <vSelect
              label="name"
              placeholder="Уровень"
              v-model="level"
              :options="levels"
          />
        </div>
        <div class="col-lg-4">
          <vSelect
              label="name"
              placeholder="Тип"
              v-model="type"
              :options="types"
          />
        </div>
      </div>
    </div>
    <div class="know-content">
      <div class="files-wrapper knowledge-cards-wrapper mt-5">
        <div class="row">
          <div v-for="material in filteredMaterisl" :key="material.id" class="col-lg-4 mb-3">
            <div class="card">
              <div class="card-img-wrapper">
                <img class="card-img-top"
                     :src="`${backEndUrl}${material.image}`"
                     alt="Card image cap">
              </div>
              <div class="card-body">
                <h5 class="card-title">{{ material.name }}</h5>
                <p class="card-text">{{ material.short_description }}</p>
                <div class="d-flex align-items-center justify-content-between">
                  <a
                      href="#"
                      class="btn btn-secondary">{{'Подробнее'}}</a>
                  <a
                      :href="`${backEndUrl}/storage/${material.link.download_link}`"
                      :download="material.link.name"
                      class="btn btn-primary">{{'Скачать'}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import vSelect from 'vue-select'
import { createNamespacedHelpers } from 'vuex';
import { backEndUrl } from '@/helpers/consts';
const {
  mapActions,
  mapState,
} = createNamespacedHelpers('materials');

export default {
  name: "Knowledge",
  components: {
    vSelect
  },
  computed: {
    ...mapState({
      materials: (state) => state.materials,
      appointments: (state) => state.appointments,
      types: (state) => state.types,
      levels: (state) => state.levels,
    }),
    filteredMaterisl() {
      return this.materials.filter((material) => {
        if (this.type?.id) {
          return material.type_id === this.type.id;
        }
        if (this.level?.id) {
          return material.level_id === this.level.id;
        }
        if (this.appointment?.id) {
          return material.appointment_id === this.appointment.id;
        }
        if (this.searchQuery) {
          return material.name.indexOf(this.searchQuery) !== -1;
        }
        return material;
      });
    },
  },
  data() {
    return {
      backEndUrl,
      filterOptions: {
        appointment: this.appointments,
        type: this.types,
        level: this.levels,
      },
      appointment: '',
      type: '',
      level: '',
      activeFullDescription: '',
      searchQuery: '',
    };
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
